import React from "react";

import GuestHeader from "./GuestHeader";
import GuestFooter from "./GuestFooter";
import GuestRoutes from "../../../routes/GuestRoutes";
import Seo from "@/seo/Seo";

class GuestLayout extends React.Component {
  render() {
    const { history } = this.props;

    return (
      <div>
        <GuestHeader history={history} />
        <Seo />
        <main id="main-content">
          <GuestRoutes history={history} />
        </main>
        <GuestFooter history={history} />
      </div>
    );
  }
}

export default GuestLayout;
